import { defineComponent, computed, useSlots, openBlock, createElementBlock, normalizeClass, normalizeStyle, renderSlot, createCommentVNode } from "vue";
import { u as useComponentPresetProp } from "../../composables/useComponentPreset.js";
import { u as useColors } from "../../composables/useColors.js";
const _hoisted_1 = ["aria-orientation"];
const _hoisted_2 = {
  key: 0,
  class: "va-divider__text"
};
const prefixClass = "va-divider";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "VaDivider"
  },
  __name: "VaDivider",
  props: {
    ...useComponentPresetProp,
    vertical: { type: Boolean, default: false },
    dashed: { type: Boolean, default: false },
    inset: { type: Boolean, default: false },
    orientation: {
      type: String,
      default: "center",
      validator: (value) => ["left", "right", "center"].includes(value)
    },
    color: { type: String, default: "backgroundBorder" }
  },
  setup(__props) {
    const props = __props;
    const { getColor } = useColors();
    const colorComputed = computed(() => getColor(props.color));
    const slots = useSlots();
    const hasSlot = computed(() => !!slots.default);
    const classComputed = computed(() => ({
      [`${prefixClass}--vertical`]: props.vertical,
      [`${prefixClass}--inset`]: props.inset,
      [`${prefixClass}--${props.orientation}`]: props.orientation && !props.vertical,
      [`${prefixClass}--dashed`]: props.dashed
    }));
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        role: "separator",
        class: normalizeClass(["va-divider", classComputed.value]),
        "aria-orientation": __props.vertical ? "vertical" : "horizontal",
        "aria-hidden": true,
        style: normalizeStyle(`--va-color-computed: ${String(colorComputed.value)}`)
      }, [
        hasSlot.value && !__props.vertical ? (openBlock(), createElementBlock("div", _hoisted_2, [
          renderSlot(_ctx.$slots, "default")
        ])) : createCommentVNode("", true)
      ], 14, _hoisted_1);
    };
  }
});
export {
  _sfc_main as _
};

import '../../../VaDivider.css';
//# sourceMappingURL=VaDivider.vue_vue_type_script_setup_true_lang.js.map
